import { Cursor } from "./cursor";

function createInputMock(): HTMLInputElement {
    return {
        selectionStart: 0,
        selectionEnd: 0,
        setSelectionRange(start, end) {
            this.selectionStart = start;
            this.selectionEnd = end;
        },
        value: ""
        // eslint-disable-next-line
    } as any;
}

describe("Cursor", () => {
    it("should keep a cursor at end of a value", () => {
        const ob = createInputMock();

        const cursor = new Cursor();
        cursor.input = ob;

        ob.value = "120";
        ob.setSelectionRange(3, 3);

        cursor.store();

        ob.value = "1.200";

        cursor.restore();

        expect(ob.selectionStart).toEqual(5);
        expect(ob.selectionEnd).toEqual(5);
    });

    it("should move a cursor in text direction", () => {
        const input = createInputMock();

        const cursor = new Cursor();
        cursor.input = input;

        input.value = "120";
        input.setSelectionRange(1, 1);

        cursor.store();

        input.value = "1.020";

        cursor.restore();

        expect(input.selectionStart).toEqual(3);
        expect(input.selectionEnd).toEqual(3);
    });
});
